import { Col, Container, Row } from "react-bootstrap";
import {
  PolicyTitle,
  SectionAnswer,
  SectionQuestion,
  SectionTitle,
  TermsContainer,
} from "./style";
import { TabWrapper } from "../style";
import Sections from "./Sections";

function TermsPage() {
  const { sections } = Sections();
  return (
    <TermsContainer>
      <TabWrapper>
        <Container>
          <Row className="justify-content-center">
            <Col
              xs={11}
              sm={10}
              md={9}
              lg={8}
              xl={7}
              className="d-flex flex-column"
              style={{ marginTop: 48 }}
            >
              <SectionTitle>About TradingView</SectionTitle>
              <SectionAnswer>
                <span>
                  <p>
                    Aevo uses TradingView technology to display price data on
                    charts. TradingView is globally recognized as a leading
                    platform for charting and trading, offering an extensive
                    array of technical, drawing, and analytical tools. Powered
                    by robust technologies available on web browsers, desktop
                    applications, and mobile apps, this platform delivers
                    unparalleled access to real-time data e.g.{" "}
                    <a
                      href="https://www.tradingview.com/symbols/CBOT_MINI-YM1!/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Dow Futures
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.tradingview.com/symbols/BTCUSD/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      BTC USD Chart
                    </a>
                    , the latest financial news, Stock screener and Economic
                    calendar.
                  </p>
                </span>
              </SectionAnswer>

              <PolicyTitle>AEVO - Terms of Service</PolicyTitle>
              {sections.map((section) => (
                <>
                  <SectionTitle>{section.sectionName}</SectionTitle>
                  {section.questions.map((question) => (
                    <>
                      <SectionQuestion>{question.question}</SectionQuestion>
                      <SectionAnswer>{question.answer}</SectionAnswer>
                    </>
                  ))}
                </>
              ))}
            </Col>
          </Row>
        </Container>
      </TabWrapper>
    </TermsContainer>
  );
}

export default TermsPage;
